import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { handleActions } from 'redux-actions';
import { queueSafetyChangeForDeviation, recordDeviationSafety, setPageSafety } from './actions';
import { reduxKey } from './constants';
const handler = handleActions({
    [setPageSafety.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            currentSafety: action.payload.safety
        }),
    [recordDeviationSafety.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            deviationSafety: _object_spread_props(_object_spread({}, state.deviationSafety), {
                [action.payload.deviationId]: action.payload.safety
            })
        }),
    [queueSafetyChangeForDeviation.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            queuedDeviationId: action.payload.deviationId
        })
}, {
    currentSafety: 'off',
    deviationSafety: {}
});
const reducers = {
    [reduxKey]: handler
};
export default reducers;
